import { Injectable } from '@angular/core';
import {
  CreateOrderParams,
  OrderApiService,
} from '@features/order/services/order-api/order-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { HttpError } from '@rd/types/http-error.type';
import { Order } from '@rd/types/order.type';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as actions from '../actions/order-create.actions';

@Injectable()
export class CreateOrderEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private orderApiService: OrderApiService,
  ) {}

  createOrderCheckout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.CreateOrderActionTypes.CREATE_ORDER_CHECKOUT),
      switchMap((payload: { createOrderParams?: CreateOrderParams }) => {
        const { createOrderParams } = payload;
        return this.orderApiService.createOrder(createOrderParams).pipe(
          map((order: Order) => actions.CreateOrderSuccess({ order })),
          catchError((error: HttpError) => of(actions.CreateOrderFail(error))),
        );
      }),
    ),
  );
}
